import React, { Component } from "react";
import moment from "moment";
import BigCalendar from "react-big-calendar";
import { NotificationManager } from "react-notifications";
import HandleError from "../../../services/HandleError";
import DaysOffService from "../../../services/DaysOffService";
import DayOffRequestsService from "../../../services/DayOffRequestsService";
import DayOffTypesService from "../../../services/DayOffTypesService";
import DayOffRequestModal from "../../modals/DayOffRequestModal";
import DayOffDetailsModal from "../../modals/DayOffDetailsModal";
import DeleteModal from "../../modals/DeleteModal";
import DayOffItem from "../../partials/DayOffItem";
import { hasRole } from "../../helpers/Permissions";

// moment.locale("es-es", { week: { dow: 1 } }); // Monday is the first day of the week.
BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class CalendarForm extends Component {
	state = {
		isSuperAdmin: hasRole(1),
		isLoadingDaysOff: true,
		isLoadingSuperAdmins:true,
		isLoadingDayoffTypes: true,
		isMakingRequest: false,
		showRequestModal: false,
		showDetailsModal: false,
		selectedType: null,
		selectedSuperAdmin: null,
		dayOffToDelete: null,
		isDeleting: false,
		start: null,
		end: null,
		daysOff: [],
		dayOffTypes: [],
		formData: {},
		errors: {},
	}

	componentDidMount = () => { 
		this.getDaysOff();  
		this.getDayOffTypes();
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } }); };
	
	onDateChange = (date,name) => {
		if(date) {
			const formatedDate = moment(date).format("YYYY-MM-DD");
			this.setState({ [name]: date.toISOString(), formData: { ...this.state.formData, [name]: formatedDate} });
		} else {
			this.setState({  [name]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}
	
	onSelectChange = (option, name, selected)  => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" }});
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onSubmit = () => {
		const errors = this.validateDate(this.state.start, this.state.end);
		this.setState({ errors });
		if(Object.keys(errors).length === 0) {
			this.setState({ isMakingRequest: true });
			this.dayOffRequestService.store(this.state.formData).then((res) => {
				this.handleCloseRequestModal();
				this.setState({ 
					isMakingRequest: false,
					daysOff: [...this.state.daysOff, (res.data || null)]
				});
				NotificationManager.success("Request sent.", "Success!");
			}).catch((err) => {
				this.setState({ isMakingRequest: false });
				HandleError(err, this);
			});
		}
	}

	getDaysOff = () => {
		this.setState({ isLoadingDaysOff: true });
		this.daysOffService.index(0).then((res) => {
			this.setState({ 
				isLoadingDaysOff: false,
				daysOff: res.data || []
			});
		}).catch((err) => {
			this.setState({ isLoadingDaysOff: false });
			HandleError(err, this);
		});
	}
	
	getDayOffTypes = () => {
		this.dayOffTypesService.index(0,"category=leave").then((res) => {
			this.setState({ 
				isLoadingDayoffTypes: false, 
				dayOffTypes: this.mapTypesToSelectOption(res.data) });
		}).catch((err) => {
			this.setState({ isLoadingDayoffTypes: false });
			HandleError(err, this);
		});
	}

	dayOffToDelete = (dayoff) => {
		if(dayoff !== null) {
			this.handleClose();
			this.setState({ dayOffToDelete : {name: dayoff.name, id: dayoff.id, type_id: dayoff.type_id} });
		}
	}
	
	deleteDayOff = () => {
		if(this.state.dayOffToDelete) {
			this.setState({ isDeleting: true });
			this.daysOffService.delete(this.state.dayOffToDelete.id, this.state.dayOffToDelete.type_id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Day Off deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {	
				this.getDaysOff(this.state.pageState);		
				this.clodeDeleteModal();
			});
		}
	}

	handleClose = () => { this.setState({ showDetailsModal: false,}); }

	clodeDeleteModal = () => {
		this.setState({
			dayOffToDelete: null,
			isDeleting: false,
		});
	}

	handleCloseRequestModal = () => {
		this.setState({
			showRequestModal: false, 
			selectedSuperAdmin: null,
			selectedType: null,
			formData: {},
			errors: {}
		});
	}

	handleRequestModal = (e) => {
		if(e && e.start && e.end) {
			this.setState({ 
				showRequestModal: true,
				start: e.start.toISOString(),
				end: e.end.toISOString(),
				formData: {
					...this.state.formData, 
					start: moment(e.start).format("YYYY-MM-DD"),
					end: moment(e.end).format("YYYY-MM-DD"),
				},
				errors: {}
			});
		}
	}
	
	handleDayOffDetailsModal = (dayoff) => {
		if(dayoff) {
			this.setState({ 
				showDetailsModal: true,
				selectedDayOff: dayoff
			});
		}
	}

	loadReporterId = (user) => {
		if(user && user.reporter && user.reporter.id) {
			return user.reporter.id;
		} 
		if(user && user.id && user.full_name) {
			return user.id;
		}
		return null;
	}

	loadSelectedRepoter = (user) => {
		if(user && user.reporter && user.reporter.id && user.reporter.full_name) {
			return { label: user.reporter.full_name, value: user.reporter.id};
		} 
		if(user.id && user.full_name) {
			return { label: user.full_name, value: user.id};
		}
		return null;
	}


	mapSuperAdminsToSelectOption = (superadmin) => {
		if (superadmin && Array.isArray(superadmin)) {
			return superadmin.map((item) => ({value: item.id, label: item.full_name }));
		}
		return [];
	}

	mapTypesToSelectOption = (types) => {
		if (types && Array.isArray(types)) {
			return types.map((item) => ({value: item.id, label: item.name }));
		}
		return [];
	}

	eventPropGetterFunction = (event) => {
		switch (event.country_id) {
		case 1:
			return ({ className: "all" });			
		case 2:
			return ({ className:  "albania-days-off" });
		case 3: 
			return ({ className:  "kosovo-days-off" });	
		default: break;
		}
		return ({ className: "" });
	}

	validateDate = (start, end) => {
		const errors = {};
		if(start && end) {
			const startDate = moment(start);
			const endDate = moment(end);;
			if(endDate.isBefore(startDate)) {
				errors.end = "End date should be after start date.";
			}
		}
		return errors;
	};

	daysOffService = new DaysOffService(this)
	dayOffTypesService = new DayOffTypesService(this,"/name")
	dayOffRequestService = new DayOffRequestsService(this)

	render() {
		const { isLoadingDaysOff, daysOff, errors, formData, showRequestModal, 
			start, end, showDetailsModal, selectedDayOff, selectedType, selectedSuperAdmin,
			isLoadingSuperAdmins, dayOffTypes, isLoadingDayoffTypes, isMakingRequest, isSuperAdmin
		} = this.state;

		return (
    		<React.Fragment>
				<div className={`loading-screen ${isLoadingDaysOff ? "is-loading": ""}`}><span>Loading...</span></div>
				<BigCalendar
					popup
					selectable
					events={daysOff}
					views={["month"]}
					defaultDate={new Date()}
					startAccessor="start"
					endAccessor="end"
					className="days-off-calendar"
					titleAccessor={(e) => DayOffItem(e) }
					tooltipAccessor={() => null}
					eventPropGetter={event => this.eventPropGetterFunction(event)}
					onSelectSlot={this.handleRequestModal} 
					onSelectEvent={this.handleDayOffDetailsModal} 
				/>

				<DayOffRequestModal 
					isMakingRequest={isMakingRequest}
					isLoadingSuperAdmins={isLoadingSuperAdmins}
					isLoadingDayoffTypes={isLoadingDayoffTypes}
					showRequestModal={showRequestModal}
					formData={formData}
					errors={errors}
					start={start}
					end={end}
					dayOffTypes={dayOffTypes}
					selectedType={selectedType}
					selectedSuperAdmin={selectedSuperAdmin}
					onSubmit={this.onSubmit}
					onChange={this.onChange}
					onDateChange={this.onDateChange}
					onSelectChange={this.onSelectChange}			
					handleCloseRequestModal={this.handleCloseRequestModal}
				/>

				<DayOffDetailsModal 
					showDetailsModal={showDetailsModal}
					isSuperAdmin={isSuperAdmin}
					handleClose={this.handleClose}
					selectedDayOff={selectedDayOff}
					dayOffToDelete={this.dayOffToDelete}
				/>	

				<DeleteModal
    				itemToDelete={this.state.dayOffToDelete}
    				deleteItem={this.deleteDayOff}
    				isDeleting={this.state.isDeleting}
    				closeModal={this.clodeDeleteModal}
    			/>	
			</React.Fragment>
		);
	}
}

export default CalendarForm;




// WEBPACK FOOTER //
// ./src/components/forms/days-off/CalendarForm.js